/*eslint-disable*/
import React from 'react'
import PropTypes from 'prop-types'
import accounting from 'accounting'
import {Widths} from './constants'
accounting.settings.currency.precision = 0;
const {goToProject, openPO} = window.unifierExtensions;

const Row = (props)=>{
  const {gen_contractnumber_tb,gen_vendorname_tb,poRecordNo,poAmount,gen_projectid_tb,project_id,gen_projectname_spn,conAmount,con_remainingbalance_ca,poID} = props;

  return (
    <tr>
      <td width={Widths.contractNo} >{gen_contractnumber_tb}</td>
      <td width={Widths.vendor} className="limit-md">{gen_vendorname_tb}</td>
      <td width={Widths.project} className="limit-lg">
        <a href="#" onClick={(e)=>{
          e.preventDefault();
          goToProject(project_id)
        }}>
          {`${gen_projectid_tb}: ${gen_projectname_spn}`}
          </a>
      </td>
      <td width={Widths.poNo}>
        <a href="#"
           onClick={(e)=>{
             e.preventDefault();
             openPO({project_id,poID})
           }}>
          {poRecordNo}
          </a>
      </td>
      <td width={Widths.poAmount} className="text-right">{accounting.formatMoney(poAmount)}</td>
      <td width={Widths.amount} className="text-right">{accounting.formatMoney(conAmount)}</td>
    </tr>
  )
};

Row.propTypes = {};
Row.defaultProps = {};

export default Row;


// WEBPACK FOOTER //
// ./src/components/Row.jsx